import Close from "@mui/icons-material/Close";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { IconButton, Modal, Slider, Stack, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_TAKE_5_RECORDINGS } from "../../constant/Apipath";
import { BILightGrey } from "../../assets/helpers";

export default function ClientViewRecordings({ open, onClose, takeFiveId }) {
  const [recordingData, setRecordingData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [pageNO, setPageNO] = useState(1);
  const { loginData,selectedClientData } = useSelector((state) => state?.main);

  useEffect(() => {
    if (open) fetchRecordings();
  }, [open]);

  const fetchRecordings = async () => {
    let obj = {
      PageNr: pageNO,
      NrOfRecPerPage: 7,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SearchList: [
        {
          clientTake5Id: takeFiveId,
        },
      ],
      SortList: [{ FieldName: "DateCreated", Direction: "DESC" }],
    };

    let res = await Postrequestcall(
      FETCH_CLIENT_TAKE_5_RECORDINGS,
      obj,
      loginData?.accessToken,
    );

    if (res.status === 200) {
      if (res?.data?.data?.length > 0) {
        setHasMore(true);
        setPageNO((prev) => prev + 1);

        let temp = [];
        res?.data?.data?.map((data) => {
          temp.push({
            ...data,
            isPlaying: false,
          });
        });

        setRecordingData((prev) => [...prev, ...temp]);
      } else {
        setHasMore(false);
      }
    }
  };

  const handelClose = () => {
    onClose();
    setRecordingData([]);
    setHasMore(true);
    setPageNO(1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handelClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <IconButton onClick={() => handelClose()}>
              <Close sx={{ color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }} />
            </IconButton>
          </div>

          <InfiniteScroll
            dataLength={recordingData?.length}
            next={fetchRecordings}
            hasMore={hasMore}
            loader={<Loader />}
            height={400}
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              scrollbarWidth: "none",
            }}
          >
            {recordingData?.map((item, index) => (
              <ClientTakeFiveAudio
                index={index}
                data={item}
                key={index}
                setRecordingData={setRecordingData}
                selectedClientData={selectedClientData}
              />
            ))}
          </InfiniteScroll>
        </div>
      </Modal>
    </>
  );
}

const ClientTakeFiveAudio = ({ data, setRecordingData, index, selectedClientData }) => {

  
  const [toggle, setToggle] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!data.isPlaying) {
      setToggle(false);
      audioRef.current.currentTime = 0;
      audioRef.current.pause();
      setCurrentTime(0);
    }
  }, [data]);

  useEffect(() => {
    if (currentTime === duration + 1) {
      setToggle(false);
      setCurrentTime(0);
      audioRef.current.currentTime = 0;
    }
  }, [currentTime]);

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
    if (audioRef.current.currentTime === audioRef.current.duration) {
      setToggle(false);
    }
  };

  const handleLoadedMetadata = (e) => {
    setDuration(audioRef.current.duration);
  };

  const handleSeek = (event) => {
    audioRef.current.currentTime = event.target.value;
    setCurrentTime(event.target.value);
  };

  const handleTogglePlay = () => {
    if (toggle) {
      audioRef.current.pause();
      setRecordingData((prev) =>
        prev?.map((item) => ({ ...item, isPlaying: false })),
      );
    } else {
      audioRef.current.play();
      setRecordingData((prev) =>
        prev?.map((item) =>
          item.id === data.id
            ? { ...item, isPlaying: true }
            : { ...item, isPlaying: false },
        ),
      );
    }

    setToggle(!toggle);
  };

  return (
    <Stack sx={{ display: "flex", marginRight: "1px",  marginBottom: 1,  padding: 1 }} key={index} container direction={"column"} border={"1px solid #e4e4e4"} borderRadius={2}>
      <Typography>
        {moment(data.dateCreated).format("MMMM DD, YYYY")}
      </Typography>

      <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"} width={"100%"}>
        <IconButton
          size="small"
          style={{
            marginRight: "10px",
          }}
          onClick={() => {
            handleTogglePlay();
          }}
        >
          {!toggle ? (
            <PlayArrowRoundedIcon fontSize="large" />
          ) : (
            <PauseRoundedIcon fontSize="large" />
          )}
        </IconButton>
        <Slider
          style={{
            flexGrow: 3,
            width: "100%",
            color:selectedClientData?.AccentColor
          }}
          step={0.01}
          type="range"
          max={duration}
          value={currentTime}
          onChange={handleSeek}
        />
        <Typography flexGrow={1} sx={{ marginLeft: 1 }}>
          {moment.utc(duration * 1000).format("m:ss")}
        </Typography>
      </Stack>

      <audio
        ref={audioRef}
        src={data?.fileUrl}
        type="audio/mp3"
        hidden
        controls
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        name="media"
      ></audio>
    </Stack>
  );
};
